import { Accordion, AccordionDetails, AccordionSummary, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React from 'react'
import moment from 'moment';
import { displayDateFormatShort } from '../../../constants';
import { trackActivity } from '../../../utils/mixpanel';
import NumericLabel from 'react-pretty-numbers';
import { ExpandMore } from '@mui/icons-material';
import { titanAviationIntance } from '../../../shared_elements';

const OffsetItemsModal = ({ onToggleModal, offsetListModal, invoiceType, isSummaryInvoice }) => {

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `View Credit Note Offset Modal`, page_type: page_type, })
    }
    return (
        <>
            <Dialog aria-labelledby="customized-dialog-title" className='add-lease-dialog' maxWidth="md" fullWidth open={true}>
                <DialogTitle sx={{ m: 0, p: 1, pl: 3 }} className='dialog-header' id="customized-dialog-title">
                    {invoiceType?.value === 5 ? 'View Parent Invoice Offset' : 'View Credit Note Offset'}
                </DialogTitle>
                <DialogContent dividers sx={{ pb: 1 }}>
                    <div>
                        {offsetListModal?.data?.transactions?.map((item, index) =>
                        <Accordion elevation={3} className="accordion-item" disableGutters key={index}>
                            <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel1-content" id="panel1-header">
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <Typography>Payment No : {item.payment_no}</Typography>
                                    <Typography>Payment Date : {item?.payment_date}</Typography>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails sx={{ padding: '0px' }}>
                                <Paper>
                                    <div style={{ overflowX: 'auto' }}>
                                        <Table className='mui-table-format' stickyHeader>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ minWidth: "100px" }} >Item</TableCell>
                                                    {!titanAviationIntance && <TableCell sx={{ minWidth: "140px" }} >Description</TableCell>}
                                                    <TableCell align='center' sx={{ minWidth: "100px" }}>Invoice Amount</TableCell>
                                                    <TableCell align='center' sx={{ minWidth: "100px" }}>Offset Amount</TableCell>
                                                    <TableCell sx={{ minWidth: "140px" }} align='right'>Remaining Amount</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {item?.items?.map((item, index) =>
                                                    <TableRow index={index}>
                                                        <TableCell>{item.item || '--'}</TableCell>
                                                        {!titanAviationIntance && <TableCell>{item.description || '--'}</TableCell>}
                                                        <TableCell align='center' ><NumericLabel params={{ locales: 'en-GB', currency: true, currencyIndicator: 'usd', precision: 2, commafy: true, justification: 'L' }}>{item.invoice_amount || 0.00}</NumericLabel></TableCell>
                                                        <TableCell align='center'><NumericLabel params={{ locales: 'en-GB', currency: true, currencyIndicator: 'usd', precision: 2, commafy: true, justification: 'L' }}>{item.offset_amount || 0.00}</NumericLabel></TableCell>
                                                        <TableCell align='right' ><NumericLabel params={{ locales: 'en-GB', currency: true, currencyIndicator: 'usd', precision: 2, commafy: true, justification: 'L' }}>{item.remaining_amount || 0.00}</NumericLabel></TableCell>
                                                    </TableRow>)}
                                            </TableBody>
                                        </Table>
                                    </div>
                                </Paper>
                            </AccordionDetails>
                        </Accordion>)}
                    </div>
                </DialogContent>
                <DialogActions sx={{ marginRight: "15px" }}>
                    <Button className='cancel-btn' variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}> Close </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default OffsetItemsModal